import { EmailArrowLeftIcon } from './EmailArrowLeftIcon';

/**
 * author: Michael Richins
 * id 68040E6F-6BCD-4505-94D6-55D1E11E82ED
 * name email-arrow-left
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-arrow-left.svg
 * tags
 */
export const EmailReceiveIcon = EmailArrowLeftIcon;
export default EmailReceiveIcon